import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-feed-video',
  templateUrl: './feed-video.component.html',
  styleUrls: ['./feed-video.component.scss']
})
export class FeedVideoComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<FeedVideoComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any) { }
  ngOnInit(): void {
  }
  dialogClose(){
    this.dialogRef.close()
  }
}
